export { default as DEFAULT_IMAGE } from './default_cover.png'

export const DEFAULT_COLOR = '#fff'
export const DEFAULT_NAME = 'Server Name'
export const DEFAULT_SERVER_VERSION = '1.0.0'
